/**
 * Globa header.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalHeader {
  /**
   * Constructs a new global header component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.hurdler = options.hurdler
    this.navItems = this.element.queryAll('li')

    this.navItems.forEach((element) => {
      element.addEventListener('click', (e) => {
        const index = this.navItems.indexOf(element)
        this.reset(this.navItems)
        this.activate(element, index)
      })
    })
  }

  reset () {
    this.navItems.forEach((element) => {
      element.classList.remove('active')
    })
  }

  activate (element, index) {
    element.classList.add('active')
  }

}



// WEBPACK FOOTER //
// ./components/global-header/index.js